'use strict'

import axios from 'axios'
import { Message, Loading } from 'element-ui'

let loadingInstance = null

let loadingCount=0;


// before send
// axios.interceptors.request.use((config) => {
// 	loadingInstance = Loading.service({
// 		fullscreen: true,
// 		lock: true
// 	})
	
// 	return config
// })

// request complete
// axios.interceptors.response.use((response) => {
// 	loadingInstance.close()
// 	return response
// })
function dealLoading(notLoading){
	if(!notLoading){
		//closeLoding();
		loadingCount++;
		loadingInstance = Loading.service({
			fullscreen: true,
			lock: true
		})
	
	}
} 
function closeLoding(){
	loadingCount>0 && loadingCount--;
	//console.log(loadingCount);
	(loadingCount===0)&&loadingInstance && loadingInstance.close();
}

export default { 
	name: 'api',
	post(url, data, successCallback,notLoading) {

		if (url.indexOf('sendSignupEmail') == -1 && url.indexOf('signupActivate') == -1 && url.indexOf('resendSignupEmail') == -1 && url.indexOf('sendResetPwdEmail') == -1) {
			const token = sessionStorage.getItem('token')

			if (token) {
				data.header.token = token
			}
		}
		dealLoading	(notLoading)

		axios.post(url, data)
			.then((response) => {
			//	console.log(response)
				closeLoding()
				if (response.data.header.returnCode == '100001') {
					window.location.href = '#/account/login'
				} else {
				//	console.log(response)
					successCallback(response)
				}
			})
			.catch((error) => {
				closeLoding()
				console.log(error)
				// loadingInstance.close()
				// Message.error('服务器异常,请稍后重试')
			})
	}
}



// WEBPACK FOOTER //
// ./src/utils/http.js